import HttpServices from './HttpServices';
import { ProductRequestResult, SearchRequest } from './SearchProductFeedTypes';

interface HttpService {
	post: (url: string, data: any, successCallback: (response: any) => void, errorCallback: (error: any) => void) => void;
}

interface AuthService {
	getAccessToken: () => string | null;
}

export default class SearchProductFeedServices {
	private HttpServices: HttpServices;
	private BO_API_URL: string;

	private config: { headers: { Authorization?: string } };
	private accountId: string;

	constructor($http: HttpService, authServices: AuthService, accountId: string) {
		this.HttpServices = new HttpServices($http);

		if (!(window as any) || !(window as any).BEYABLE_env || !(window as any).BEYABLE_env.BO_API_URL) {
			throw new Error('Configuration [window.BEYABLE_env.BO_API_URL] missing');
		} else {
			this.BO_API_URL = `${(window as any).BEYABLE_env.BO_API_URL}`;
		}
		// @ts-ignore
		this.SERVER_URL = (window as any).BEYABLE_env.SERVER_URL;

		const token = authServices && authServices.getAccessToken();
		this.config = { headers: {} };

		if (token) {
			this.config.headers.Authorization = 'Bearer ' + token;
		}

		this.accountId = accountId;
	}

	postSearchEmptyTenant(
		objetSearch: SearchRequest,
		callbackSuccess: (response: ProductRequestResult) => void,
		callbackError: (error: any) => void,
		callbackNoCatalog?: () => void
	): void {
		this.HttpServices.post(
			`${this.BO_API_URL}${this.accountId}/products/request`,
			objetSearch,
			callbackSuccess,
			(message, error) => {
				if (error.status === 404) {
					callbackNoCatalog ? callbackNoCatalog() : callbackError(message);
				} else {
					callbackError(message);
				}
			}
		);
	}

	postSearchWithTenant(
		objetSearch: SearchRequest,
		tenant: string,
		callbackSuccess: (response: ProductRequestResult) => void,
		callbackError: (error: any) => void,
		callbackNoCatalog?: () => void
	): void {
		this.HttpServices.post(
			`${this.BO_API_URL}${this.accountId}/${tenant}/products/request`,
			objetSearch,
			callbackSuccess,
			(message, error) => {
				if (error.status === 404) {
					callbackNoCatalog ? callbackNoCatalog() : callbackError(message);
				} else {
					callbackError(message);
				}
			}
		);
	}
}